export default () => {
  if (process.env.VUE_APP_ENABLE_DEBUG === 'false') {
    const query = window.location.href.split('?')[1];
    const domain = process.env.VUE_APP_MAPLIST_URL;
    window.location.href = `${domain}maintenance?${query}`;
  }
};
